export default "__VITE_ASSET__BnKnBede__"